module.exports = __webpack_public_path__ + "files/5b597628905a58ef42c0e5dbe0a69659.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/exo2-bolditalic-webfont.eot
 ** module id = 405
 ** module chunks = 0
 **/